
export default function Footer() {
  return (
    <footer className="bg-[#EA9D00] py-8 sm:py-12 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-4 sm:space-y-6">
          <div className="text-[#2A2A2A]">
            <p className="text-base sm:text-lg font-semibold mb-2">Mix Express</p>
            <p className="text-xs sm:text-sm">Transformando profissionais em referências</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-xs sm:text-sm text-[#2A2A2A]">
            <a href="#" className="hover:underline cursor-pointer whitespace-nowrap">
              Política de Privacidade
            </a>
            <a href="#" className="hover:underline cursor-pointer whitespace-nowrap">
              Termos de Uso
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:underline cursor-pointer whitespace-nowrap">
              Website Builder
            </a>
          </div>

          <div className="pt-4 sm:pt-6 border-t border-[#2A2A2A]/20">
            <p className="text-xs sm:text-sm text-[#2A2A2A]">
              © 2025 Mix Express. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
